import React from "react";

export default function Home() {
  const currentYear = new Date().getFullYear();

  return (
    <div className="min-h-screen bg-white text-slate-800 font-sans">

      {/* Hero */}
      <section
        id="home"
        className="bg-gradient-to-br from-[#163248] via-[#1f3d5c] to-[#163248] text-white"
      >
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-28 grid md:grid-cols-2 gap-12 items-center">
          <div>
            <p className="uppercase tracking-[0.25em] text-xs text-[#6ec87a] mb-4">
              Trusted Healthcare Support
            </p>
            <h1 className="text-4xl md:text-5xl leading-tight font-semibold mb-6">
              Reliable Healthcare and Medical Support Services for Institutions and Patients
            </h1>
            <p className="text-slate-200 text-base md:text-lg leading-8 max-w-2xl mb-8">
              M3 Global Medicare LLP provides healthcare support, medical coordination,
              and related service solutions with a focus on professionalism,
              responsiveness, and operational reliability.
            </p>
            <div className="flex flex-wrap gap-4">
              <a href="#contact" className="bg-[#6ec87a] text-[#163248] font-semibold px-6 py-3 rounded-xl hover:opacity-90 transition">
                Contact Us
              </a>
              <a href="#services" className="border border-white/20 text-white px-6 py-3 rounded-xl hover:bg-white/10 transition">
                View Services
              </a>
            </div>
          </div>

          <div className="bg-white/10 border border-white/10 rounded-2xl p-6 md:p-8 backdrop-blur-sm">
            <h2 className="text-xl font-semibold mb-5">Business Information</h2>
            <div className="space-y-4 text-sm leading-7 text-slate-100">
              <div>
                <p className="text-[#6ec87a] font-semibold">Legal Name</p>
                <p>M3 Global Medicare LLP</p>
              </div>
              <div>
                <p className="text-[#6ec87a] font-semibold">Registered Address</p>
                <p>
                  Second Floor, Old No. 877, New No. 196,<br />
                  EVR Periyar Salai, Poonamallee High Road,<br />
                  Purasawalkam, Chennai,<br />
                  Tamil Nadu – 600084, India
                </p>
              </div>
              <div>
                <p className="text-[#6ec87a] font-semibold">Email</p>
                <p>support@anything.online</p>
              </div>
              <div>
                <p className="text-[#6ec87a] font-semibold">Phone</p>
                <p>+91 96004 94225</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About */}
      <section id="about" className="bg-white">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20 grid md:grid-cols-2 gap-12 items-start">
          <div>
            <p className="text-[#6ec87a] uppercase tracking-[0.2em] text-xs font-semibold mb-3">About Us</p>
            <h2 className="text-3xl md:text-4xl font-semibold text-[#163248] mb-6">
              A professional organization focused on healthcare support and service delivery
            </h2>
            <p className="text-slate-600 leading-8 mb-5">
              M3 Global Medicare LLP is a healthcare-focused organization providing medical support
              and operational service solutions. We work with a commitment to clear communication,
              dependable execution, and quality-driven service.
            </p>
            <p className="text-slate-600 leading-8">
              Our goal is to support healthcare-related requirements through organized processes,
              responsive service, and a strong emphasis on professionalism and trust.
            </p>
          </div>
          <div className="grid sm:grid-cols-2 gap-5">
            {[
              { title: "Professional Approach", desc: "Structured, responsive, and client-focused healthcare support services." },
              { title: "Reliable Communication", desc: "Clear business communication for institutions, partners, and clients." },
              { title: "Service Quality", desc: "Delivery standards focused on consistency, trust, and operational efficiency." },
              { title: "Registered Office", desc: "Based in Chennai, Tamil Nadu, serving healthcare-related needs with professional support." },
            ].map((item) => (
              <div key={item.title} className="border border-slate-200 rounded-2xl p-6 shadow-sm">
                <h3 className="text-lg font-semibold text-[#163248] mb-3">{item.title}</h3>
                <p className="text-sm text-slate-600 leading-7">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Services */}
      <section id="services" className="bg-[#f6f9fc]">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20">
          <div className="text-center max-w-3xl mx-auto mb-12">
            <p className="text-[#6ec87a] uppercase tracking-[0.2em] text-xs font-semibold mb-3">Our Services</p>
            <h2 className="text-3xl md:text-4xl font-semibold text-[#163248] mb-5">
              Core healthcare and support service areas
            </h2>
            <p className="text-slate-600 leading-8">
              We deliver structured, professional healthcare support solutions tailored to
              institutional and individual service requirements.
            </p>
          </div>
          <div className="grid md:grid-cols-2 xl:grid-cols-4 gap-6">
            {[
              { title: "Healthcare Support Services", desc: "Professional support services designed to assist healthcare operations and service coordination." },
              { title: "Medical Service Coordination", desc: "Organized coordination support for healthcare-related service requirements and workflows." },
              { title: "Administrative Assistance", desc: "Business and operational assistance for structured healthcare service management." },
              { title: "Client Support", desc: "Responsive communication and support for service inquiries, coordination, and follow-up." },
            ].map((item) => (
              <div key={item.title} className="bg-white rounded-2xl p-6 border border-slate-200 shadow-sm">
                <h3 className="text-lg font-semibold text-[#163248] mb-3">{item.title}</h3>
                <p className="text-sm text-slate-600 leading-7">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Us */}
      <section id="why-us" className="bg-white">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20">
          <div className="text-center max-w-3xl mx-auto mb-12">
            <p className="text-[#6ec87a] uppercase tracking-[0.2em] text-xs font-semibold mb-3">Why Choose Us</p>
            <h2 className="text-3xl md:text-4xl font-semibold text-[#163248] mb-5">
              Built around trust, clarity, and dependable service
            </h2>
          </div>
          <div className="grid md:grid-cols-3 gap-6">
            {[
              { title: "Registered Business Presence", desc: "Clear organization identity, registered address, and business contact information." },
              { title: "Responsive Communication", desc: "Contact channels designed for clients, partners, and service inquiries." },
              { title: "Professional Presentation", desc: "A proper public-facing presence with real content and structured service delivery." },
            ].map((item) => (
              <div key={item.title} className="rounded-2xl border border-slate-200 p-7 shadow-sm">
                <h3 className="text-lg font-semibold text-[#163248] mb-3">{item.title}</h3>
                <p className="text-sm text-slate-600 leading-7">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact */}
      <section id="contact" className="bg-[#f6f9fc]">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20">
          <div className="text-center mb-12">
            <p className="text-[#6ec87a] uppercase tracking-[0.2em] text-xs font-semibold mb-3">Contact Us</p>
            <h2 className="text-3xl md:text-4xl font-semibold text-[#163248] mb-4">
              Get in touch with M3 Global Medicare LLP
            </h2>
          </div>
          <div className="grid lg:grid-cols-2 gap-8">
            <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-8">
              <h3 className="text-xl font-semibold text-[#163248] mb-6">Registered Address</h3>
              <div className="space-y-5 text-slate-700">
                <div>
                  <p className="font-semibold text-[#163248]">M3 Global Medicare LLP</p>
                  <p className="leading-8 mt-2">
                    Second Floor, Old No. 877, New No. 196,<br />
                    EVR Periyar Salai, Poonamallee High Road,<br />
                    Purasawalkam, Chennai,<br />
                    Tamil Nadu – 600084, India
                  </p>
                </div>
                <div>
                  <p className="font-semibold text-[#163248]">Email</p>
                  <a href="mailto:support@anything.online" className="text-[#1f5fa8] break-all hover:underline">
                    support@anything.online
                  </a>
                </div>
                <div>
                  <p className="font-semibold text-[#163248]">Phone</p>
                  <a href="tel:+91 96004 94225" className="text-[#1f5fa8] hover:underline">+91 96004 94225</a>
                </div>
                <div>
                  <p className="font-semibold text-[#163248]">Business Hours</p>
                  <p>Monday to Saturday, 9:00 AM to 6:00 PM</p>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-4">
              <iframe
                title="M3 Global Medicare LLP Location"
                src="https://www.google.com/maps?q=Second%20Floor%2C%20Old%20No.%20877%2C%20New%20No.%20196%2C%20EVR%20Periyar%20Salai%2C%20Purasawalkam%2C%20Chennai%2C%20Tamil%20Nadu%20600084&output=embed"
                className="w-full h-[420px] rounded-xl border-0"
                loading="lazy"
                allowFullScreen
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Policies */}
      <section className="bg-white border-t border-slate-200">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-10 grid md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-lg font-semibold text-[#163248] mb-3">Company Information</h3>
            <p className="text-sm text-slate-600 leading-7">
              M3 Global Medicare LLP is a registered business with a public-facing website
              providing company, service, and contact information.
            </p>
          </div>
          <div>
            <h3 className="text-lg font-semibold text-[#163248] mb-3">Privacy Policy</h3>
            <p className="text-sm text-slate-600 leading-7 mb-3">
              We are committed to handling communication and business information responsibly.
            </p>
            <a href="/paus/privacy-policy" className="text-sm font-semibold text-[#2f8f45] hover:text-[#163248] underline underline-offset-2">
              Read the PAUS Privacy Policy
            </a>
          </div>
          <div>
            <h3 className="text-lg font-semibold text-[#163248] mb-3">Terms & Disclaimer</h3>
            <p className="text-sm text-slate-600 leading-7 mb-3">
              All services are subject to applicable terms of use and service disclaimers.
            </p>
            <a href="/paus/terms-of-use" className="text-sm font-semibold text-[#2f8f45] hover:text-[#163248] underline underline-offset-2">
              Read the PAUS Terms of Use
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#163248] text-slate-300">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-sm">
          <p>© {currentYear} <span className="text-[#6ec87a] font-semibold">M3 Global Medicare LLP</span>. All rights reserved.</p>
          <div className="flex flex-wrap items-center gap-4">
            <a href="#about" className="hover:text-[#6ec87a] transition-colors">About</a>
            <a href="#services" className="hover:text-[#6ec87a] transition-colors">Services</a>
            <a href="#contact" className="hover:text-[#6ec87a] transition-colors">Contact</a>
            <a href="/paus/privacy-policy" className="hover:text-[#6ec87a] transition-colors">Privacy Policy</a>
            <a href="/paus/terms-of-use" className="hover:text-[#6ec87a] transition-colors">Terms</a>
          </div>
        </div>
      </footer>
    </div>
  );
}